<template>
  <div class="loading-bd coverF" :class="{'hidden': hidden}">
    <div class="centerF">
      <!--默认样式-->
      <div class="loading-default" v-if="type === 'default'">
        <div class="loading">
          <img src="../images/svg/loading.png" alt="">
        </div>
      </div>
      <!--点阵样式一-->
      <div class="loading-dit" v-if="type === 'dit'">
        <span v-for="item in 5"></span>
        <p v-if="text">{{text}}</p>
      </div>
    </div>
  </div>
</template>
<script>
/**
   * @param type [String] 加载动画类型,default(默认),dit(多点类型)
   * @param type [text] 加载文字
   * @describe 仅dit类型有加载文属性，加载动画有延时500ms显示效果(防止极短加载动画闪屏)
   *
   * @example
   *
    <t-loading type='dit'></t-loading>
   */

export default {
  name: 'tLoading',
  props: {
    type: { type: String, default: 'default' },
    text: { type: String, default: '' },
  },
  data() {
    return {
      hidden: true,
    };
  },
  mounted: function () {
    // 延后显示加载动画
    setTimeout(() => {
      this.hidden = false;
    }, 500);
  },
};

</script>
<style scoped lang="scss">
.loading-bd {
  z-index: 999;
  &.hidden {
    opacity: 0
  }
  .loading-default {
    color: #fff;
    padding: 0.16rem;
    text-align: center;
    border-radius: 5px;
    background: rgba(0, 0, 0, .7);
    .loading {
      width: 0.34rem;
      height: 0.34rem;
      text-align: center;
      line-height: 0.34rem;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .loading-dit span {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 0.03rem;
    border-radius: 50%;
    overflow: hidden;
    background: #4086F5;
    animation: loaddit 1.04s ease infinite;
    -webkit-animation: loaddit 1.04s ease infinite;
    &:nth-child(1) {
      -webkit-animation-delay: 0.13s;
    }
    &:nth-child(2) {
      -webkit-animation-delay: 0.26s;
    }
    &:nth-child(3) {
      -webkit-animation-delay: 0.39s;
    }
    &:nth-child(4) {
      -webkit-animation-delay: 0.52s;
    }
    &:nth-child(5) {
      -webkit-animation-delay: 0.65s;
      margin-right: 0;
    }
    p {
      text-align: center;
      font-size: 0.14rem;
      color: #464646;
      margin-top: 0.06rem;
    }
  } // 加载动画
  @-webkit-keyframes loaddit {
    0% {
      opacity: 1;
      -webkit-transform: scale(1);
    }
    100% {
      opacity: 0.2;
      -webkit-transform: scale(.3);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/loading.vue